// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#print-view {\n  display: none;\n}\n\n@media print {\n  body {\n    zoom: 60%;\n  }\n\n  #print-view {\n    display: block;\n  }\n\n  #print-view ~ div {\n    display: none;\n  }\n\n  #print-button {\n    display: none;\n  }\n}\n", ""]);
// Exports
module.exports = exports;
